<template>

<div style="margin-left: 10%">
        <pre v-if="false" id="json1">{{ survey }}</pre>
        <b-tabs content-class="mt-3" style="width:90%; padding-left: 20px; padding-top: 20px">
            <b-tab v-for="(value, key) in sections" :title="tabTitle('{{ key }}')" active
                   @click="tabClick( key)" :key="key">

                <template slot="title">
                    <div style="padding: 5px; background-color: greenyellow; font-size: 24px">
                        <font-awesome-icon icon="chess-queen" size="1x"/>
                        {{ titleCase(key.toLocaleLowerCase().replace(/_/g," ")) }}
                    </div>
                </template>
                <pre v-if="false" id="json">{{ value }}</pre>
                <div v-for="item in value" style="margin-left: 25px">
                    <b-row>
                        <b-col cols="9" class="text-left">
                            <div style="float: left">
                                <b-button v-b-toggle="`collapse-${item.name}`" size="sm"
                                          class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                                    <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>Toggle Inner Collapse
                                </b-button>
                            </div>
                            <h2>
                                <span style="color: green">Section:</span> {{ item.name }}
                            </h2>
                        </b-col>
                        <b-col cols="3">
                            <button slot="header" @click="addQuestion()">Add Question</button>
                        </b-col>
                    </b-row>
                    <b-collapse style="margin-left: 50px; width: 80%" :id="getCollapseId(item.name,null)">
                        <b-row>
                            <b-col cols="9" class="text-left">
                                <div style="float: left">
                                    <b-button v-b-toggle="`collapse-${item.name}-core`" size="sm"
                                              class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                                        <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>Toggle Inner Collapse
                                    </b-button>
                                </div>
                                <h2>
                                    <span style="color: green">CORE</span>
                                </h2>
                            </b-col>
                            <b-col cols="3">
                                <button slot="header" @click="addQuestion()">Add Question</button>
                            </b-col>
                        </b-row>
                        <b-collapse :id="getCollapseId(item.name, 'core')">
                            <draggable v-for="element in key === 'ENERGY_EFFICIENCY'.toUpperCase()  && item.name === 'Awareness & Maintenance' ?
                                pageToSubSectionMap(value).get( 'Awareness & Maintenance').get('CORE') : 'Default: '+item.name"
                                       group="people"
                                       @start="checkMove" :key="element.id"
                                       style="background-color: #95999c; width: 100%; margin-bottom: 5px"
                                       @move="handleChange"
                                       @end="onEnd" :id="element.qnum">
                                <DraggableQuestion :delete-question="deleteQuestion" :edit-question="editQuestion"
                                                   :section="key" :element="element "/>
                            </draggable>

                        </b-collapse>
                        <b-collapse :id="getCollapseId(item.name)">
                            <b-row>
                                <b-col cols="9" class="text-left">
                                    <div style="float: left">
                                        <b-button v-b-toggle="`collapse-${item.name}-elective`" size="sm"
                                                  class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                                            <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>Toggle Inner Collapse
                                        </b-button>
                                    </div>
                                    <h2>
                                        <span style="color: green">ELECTIVE</span>
                                    </h2>
                                </b-col>
                                <b-col cols="3">
                                    <button slot="header" @click="addQuestion()">Add Question</button>
                                </b-col>
                            </b-row>
                            <b-collapse :id="getCollapseId(item.name, 'elective')">
                                <draggable v-for="element in key === 'ENERGY_EFFICIENCY'.toUpperCase()  && item.name === 'Awareness & Maintenance' ?
                                pageToSubSectionMap(value).get( 'Awareness & Maintenance').get('ELECTIVE') : 'Default: '+item.name"
                                           group="people"
                                           @start="checkMove" :key="element.id"
                                           style="background-color: #95999c; width: 100%; margin-bottom: 5px"
                                           @move="handleChange"
                                           @end="onEnd" :id="element._id">
                                    <DraggableQuestion :delete-question="deleteQuestion" :edit-question="editQuestion"
                                                       :section="key" :element="element "/>
                                </draggable>
                            </b-collapse>
                        </b-collapse>
                    </b-collapse>
                </div>
            </b-tab>
            <QuestionEditorModal :value="modalOpen" :element="measureUpdate"
                                 :show="this.showModal"></QuestionEditorModal>
            <b-row style="margin: 10px 0 10px 0">

            </b-row>
        </b-tabs>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import DraggableQuestion from "./DraggableQuestion";
import Bus from "../eventBus";
import QuestionEditorModal from "./QuestionEditorModal";
import Swal from "sweetalert2";

export default {
  components: {
    QuestionEditorModal,
    DraggableQuestion,
    draggable
  },
  data() {
    return {
      survey: {},
      sections: {},
      modalOpen: false,
                showModal: true,
                measureUpdate: {}
            }
        },
        mounted() {
            let self = this;
            this.$http.get("survey/active")
                .then(result => {
                    self.survey = result.data;
                    self.sections = result.data.sections;
                }).catch(error => {
                console.error("Could not Fetch survey", error);
            })

        },
        created() {
            Bus.$on('edit-question', this.updateQnum);
            Bus.$on('question-modal', this.handleModalClose);
        },
        beforeDestroy() {
            Bus.$off('edit-question', this.updateQnum);
            Bus.$off('question-modal', this.handleModalClose);
        },
        watch: {
            months: function (newVal) {
                this.showStep(newVal);
            }
        },
        computed: {
            coreVersusElectiveMap: function () {
                let theMap = new Map();
                let self = this;
                Object.keys(this.sections).forEach((key) => {
                    let coreCount = 0;
                    let topicMap = new Map();
                    self.sections[key].forEach(section => {
                        console.log("Building map: " + section.section);
                        section.elements.forEach(element => {
                            if (element.type === 'CORE') {
                                ++coreCount;
                                let currentVal = topicMap.get(element.text);
                                topicMap.set(element.text, currentVal !== undefined ? ++currentVal : 1);
                            }
                        })


                    });
                    theMap.set(key, topicMap);
                });
                console.log("The coreVersusElectiveMap:");
                console.log(theMap);
                return theMap;
            },
            draggingInfo() {
                return this.dragging ? "under drag" : "";
            }
        },
        methods: {
            pageToSubSectionMap: function (pageList) {
                let questionMap = new Map();
                if (pageList) {
                    pageList.forEach(page => {
                        page.elements.forEach(element => {
                            questionMap.set(element.text, this.pageToTypeMap(page.elements, element.text));
                        })
                    })
                }
                console.log("SubsectionMap");
                console.log(questionMap);
                return questionMap;
            },
            pageToTypeMap: function (pageElements, subSection) {
                let questionMap = new Map();
                pageElements.forEach(element => {
                    if (element.text === subSection) {
                        var list = questionMap.get(element.type);
                        if (list) {
                            list.push(element);
                        } else {
                            list = [element];
                        }
                        questionMap.set(element.type, list);
                    }
                })
                return questionMap;
            },
            isCore: function (type) {
                return "CORE" === type;
            },
            isElective: function (type) {
                console.log("ELECTIVE" === type);
                return "ELECTIVE" === type;
            },
            getCollapseId(name, section) {
                let start = `collapse-${name}`;
                if (section) {
                    start = start + `-${section}`;
                }
                return start;
            },
            openModal() {
                this.$bvModal.show("modal-1");
                this.modalOpen = !this.modalOpen;
            },
            handleModalClose(state) {
                this.showModal = state;
            },
            updateQnum: function (id, action) {
                this.loadMeasure(id);
                this.showModal = !this.showModal;
                return true;
            },
            handleChange: function (evt) {
                console.log("Current Index" + evt.draggedContext.index);
                console.log("Future Index" + evt.draggedContext.futureIndex);
                return true;
            },
            loadMeasure: function (id) {
                let self = this;
                this.$http.get("/measures/" + id)
                    .then(response => {
                        self.measureUpdate = response.data;
                    })
                    .catch(error => {
                        console.log("Unable to load measure for editing.")
                        let title = "Unable to Load Measure for Editing!"
                        Swal.fire({
                            title: title,
                            text: 'Unable to load measure for editing. If this persists please notify administrator.',
                            icon: 'error'
                        });
                    })
            },
            checkMove: function (evt, originalEvent) {
                //alert("changed" + evt + originalEvent);
                console.log("Changed Id:" + evt.target.id);
                console.log("Can question be core: " + this.coreVersusElectiveMap["WASTE_REDUCTION"]);
                this.drag = true;
            },
            onEnd: function (evt, originalEvent) {
                let measure = this.findMeasureById(this.sections, evt.target.id);
                let section = measure.sectionName;
                let groupMap = this.coreVersusElectiveMap.get(section);
                let threshold = groupMap.get(measure.measure.text) - 1;
                let newIndex = evt.newIndex;
                this.drag = newIndex > threshold;
            },
            findMeasureById: function (sections, id) {
                let self = this;
                let measureDetails;
                Object.keys(sections).forEach(key => {
                    self.sections[key].forEach(section => {
                        section.elements.forEach(element => {
                            if (element._id === id) {
                                measureDetails = {measure: element, sectionName: section.section};
                            }
                        });
                    })
                })
                return measureDetails;
            },
            capitalize: function (str) {
                if (str.length === 0) return str;
                return str[0].toUpperCase() + str.substr(1);
            },
            titleCase: function (str) {
                return str.split(' ').map(this.capitalize).join(' ');
            },
            addQuestion: function () {
                alert("Anna, this will add a question to this section of the survey.");
            },
            deleteQuestion: function (id, section) {
                alert(`Delete the question with id: ${id} in section : ${section}`);
                //this.survey.sections
            },
            editQuestion: function (id, section) {
                alert(`Edit the question with id: ${id} in section : ${section}, with the local variable: ${this.survey.surveyId}`);
                //this.survey.sections
            },
            submit: function () {
                console.log(this.firstName, this.lastName);
                this.firstName = '';
                this.lastName = '';
            },
            changedLabel: function (label) {
                //receive the label of the value selected (the label shown in the select, or an empty string)
                console.error("Label Value: " + label);
            },
            addChoice: function (label) {
                //receive the label of the value selected (the label shown in the select, or an empty string)
                console.error("Label Value: " + label);
            },
            addColumn: function (label) {
                //receive the label of the value selected (the label shown in the select, or an empty string)
                console.error("Label Value: " + label);
            },
            add(index) {
                this.choices.push({name: ''});
                console.debug("Item Index: " + index);
            },
            remove(index) {
                this.choices.splice(index, 1);
            },
            onCollapse(collapsed) {
                console.log(collapsed);
                this.collapsed = collapsed
            }
            ,
            onItemClick(event, item) {
                console.log('onItemClick' + event.name() + item.name)
            },
            tabClick(tab) {
                switch (tab) {
                    case 'first':
                        break;
                    case 'ENERGY':
                        this.survey.currentPage = "ENERGY";
                        break;

                    case 'WATER':
                        this.survey.currentPage = "WATER";
                        break;
                    default:
                        this.survey.currentPage = tab.toUpperCase().replace(" ", "_");
                        break;
                }
            },
            tabTitle(title) {
                return `${title}`;
            }
        }
    }
</script>
<style>
/*    .handle {
        float: left;
        padding-top: 8px;
        padding-bottom: 8px;
    }*/
</style>
